import React from "react";

const VideoPlaySkeleton: React.FC = () => {
  return (
    <div>
      {/* tiktok slider section */}
      <section className="py-14 blue-bg-dots max-md:py-10 landing-page-video">
        <div className="container mx-auto relative z-0">
          <div className="bg-gray-300 w-full h-[800px] max-sm:h-[200px] max-md:h-[350px] max-lg:h-[450px] max-xl:h-[600px] skeleton rounded-[50px] max-md:rounded-[35px] max-sm:rounded-3xl flex items-center justify-center">
            <span className="block w-[300px] max-lg:w-[200px] max-md:w-[120px] h-[200px] max-sm:w-[80px] max-lg:h-[140px] max-sm:h-[60px] max-md:h-[80px] max-xl:h-[160px] max-xl:w-[250px] rounded-3xl max-md:rounded-2xl max-sm:rounded-lg bg-gray-400"></span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VideoPlaySkeleton;
